export const POSTHOG_PORTAL_DISTINCT_ID_PREFIX = "portal_user:";

const POSTHOG_PORTAL_DISTINCT_ID_PATTERN = /^portal_user:[a-f0-9]{64}$/;
const POSTHOG_SDK_UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
const POSTHOG_GIT_COMMIT_SHA_PATTERN = /^(?=.*[a-f])[a-f0-9]{7,64}$/i;

export function isPostHogPortalDistinctId(value: string) {
  return POSTHOG_PORTAL_DISTINCT_ID_PATTERN.test(value.trim());
}

// The SDK's anonymous UUID can contain long digit runs. It must not pass
// through the generic phone-number filter, or the collector rejects the event.
export function isPostHogCaptureDistinctId(value: unknown): value is string {
  return typeof value === "string" &&
    (POSTHOG_SDK_UUID_PATTERN.test(value) || POSTHOG_PORTAL_DISTINCT_ID_PATTERN.test(value));
}

// Release identity comes only from the site's trusted release-property builder.
// Keep this narrower than a generic property allowlist: only a hexadecimal SHA
// can bypass value-level PII filtering, and only under these two fixed keys.
export function withPostHogTrustedReleaseIdentity(
  properties: Record<string, unknown>,
  trustedReleaseProperties: Readonly<Record<string, unknown>>,
) {
  const gitCommitSha = trustedReleaseProperties.git_commit_sha;
  if (typeof gitCommitSha !== "string" || !POSTHOG_GIT_COMMIT_SHA_PATTERN.test(gitCommitSha)) {
    return properties;
  }

  const releaseId = trustedReleaseProperties.release_id;
  return {
    ...properties,
    git_commit_sha: gitCommitSha,
    ...(releaseId === gitCommitSha ? { release_id: releaseId } : {}),
  };
}
